import logger from '../utils/rbata.logger';
import plpService from '../services/rbata.plpService';
import historyService from '../services/rbata.historyService';
import facetOverlay from './rbata.facet-overlay';
import spinner from '../utils/rbata.spinner';
import Breakpoints from 'breakpoints-js/src/breakpoints';
import parallax from '../utils/rbata.parallax';
import startCloudinaryResponsive from '../utils/rbata.cloudinary';
import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';
import productTileSlider from './rbata.tileSlider';
import rbataTileSwatches from './rbata.tileSwatches';

// fork from RBMC
const facetSelection = {
    pageBody:         undefined,
    queryUrl:         undefined,
    searchTerm:       undefined,
    currentSelection: undefined,
    cacheSelectors() {
        this.pageBody = $(document.body);
    },
    initFacet(val) {
        console.log("Init Facet query url: " + val.queryUrl);
        console.log("Init Facet search term: " + val.searchTerm);
        console.log("Init Facet current query: " + val.currentQuery);
        this.queryUrl         = val.queryUrl;
        this.searchTerm       = val.searchTerm;
        this.currentSelection = val.currentQuery;
    },
    bindHandlers() {
        this.pageBody.on('click', '.js-facet-selection', (evt) => {
            // after several code changes (customer driven) this function has nearly the same behaviour as js-facet-selection--lazy
            // for the moment fine because sorting on mobile looks the same as it is for facets but behaviour is different (contentChange = true)
            evt.preventDefault();
            const self           = evt.currentTarget;
            const dataSet        = self.dataset;
            const $currentTarget = $(self);

            logger.log(`Got click for ${dataSet.queryPart}`);
            if (dataSet.contentChange === 'false') {
                $currentTarget.toggleClass('dropdown-item--active');
            }
            if ($currentTarget.hasClass('dropdown-item--mobile-facet')) {
                $currentTarget
                        .closest('.dropdown-menu--mfacet')
                        .find('.js-facet__reset')
                        .removeClass('dropdown-toggle__reset--active');
                $('#js-apply-facet-all--lazy').removeClass('d-none');
            }
            this.handleFacetSelection(dataSet.queryPart, dataSet.contentChange);
        });
        // facet-change on desktop
        this.pageBody.on('click', '.js-facet-selection--lazy', (evt) => {
            evt.preventDefault();
            const $currentTarget = $(evt.currentTarget);

            $currentTarget.toggleClass('dropdown-item--active');
            // show apply button
            if ($currentTarget.hasClass('dropdown-item--desktop-facet')) {
                $currentTarget
                        .closest('.dropdown-menu--facet')
                        .find('.js-apply-facet-selection--lazy')
                        .removeClass('d-none')
                        .end()
                        .find('.js-facet__reset--hack')
                        .removeClass('dropdown-toggle__reset--active');
            }
        });
        // apply button on desktop
        this.pageBody.on('click', '.js-apply-facet-selection--lazy', (evt) => {
            evt.preventDefault();
            const self      = evt.currentTarget;
            let facetValues = [];

            logger.log(`Got click for apply facet selection`);
            // before adding the new active facet item remove the old one from the current selection
            this.removeFacetFromCurrentSelection(self.dataset.code);
            $(self).closest('.dropdown-menu--facet').find('.dropdown-item--active').each((index, element) => {
                const dataSet = element.dataset;

                facetValues.push(dataSet.facetName);
                this.handleFacetSelection(dataSet.queryPart, false);
            });
            this.changeAndLoadURL(this.getURL(), null);
        });
        // clear all facets
        this.pageBody.on('click', '.js-facet-clear', (evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            logger.log(`Got click for clear all facets`);
            this.handleFacetSelection(this.currentSelection, 'true');
        });
        // clear single facet
        this.pageBody.on('click', '.js-facet__reset--hack', (evt) => {
            evt.stopPropagation();
            let dataSet = evt.currentTarget.dataset;

            if ($(evt.currentTarget).hasClass('dropdown-toggle__reset--active')) {
                return;
            }
            this.resetFacet(dataSet.clear, null);
        });
        // clear one specified mobile facet
        this.pageBody.on('click', '.js-facet__reset', (evt) => {
            evt.stopPropagation();
            let dataSet = evt.currentTarget.dataset;

            this.resetFacet(dataSet.clear, () => {
                $('#facet__overlay--facets').addClass('facet__overlay--visible');
            });
        });
        // send the facet selection to the server, fetch content and show the mobile facet overlay again
        this.pageBody.on('click', '#js-apply-facet-all--lazy', (evt) => {
            let self        = evt.currentTarget;
            let facetValues = [];
            evt.preventDefault();
            logger.log(`Got click for apply facet selection`);
            // only facet values of the current open facet will be tracked
            // FIXME: user can select some values of a facet, close the facet without saving, select some values within another facet and now on save
            // only the values from last open facet will be tracked. But filtering respects all facets
            $(self).closest('.facet__overlay').find('.dropdown-item--active').each((index, element) => {
                let dataSet = element.dataset;

                facetValues.push(dataSet.facetName);
            });
            this.changeAndLoadURL(this.getURL(), () => {
                $('#facet__overlay--facets').addClass('facet__overlay--visible');
            });
        });
        // close overlay and clear facets
        this.pageBody.on('click', '.js-mfacet-clear', (evt) => {
            evt.preventDefault();
            logger.log(`Got click for clear all facets on mobile`);
            facetOverlay.close();
            this.handleFacetSelection(this.currentSelection, 'false');
            this.changeAndLoadURL(this.getURL());
        });
        // close facet overlay on entering desktop view
        Breakpoints.on('desktop', {
            enter: () => {
                facetOverlay.close();
            }
        });
    },
    removeFacetFromCurrentSelection(target) {
        let regex = new RegExp(`:${target}:[^&:]+`, 'g');

        logger.log(`Try to clear the facet "${target}"`);
        this.currentSelection = this.currentSelection.replace(regex, '');
    },
    handleFacetSelection(queryPart, changeContent) {
        this.replaceInCurrentSelection(queryPart);
        if (changeContent === 'true') {
            this.changeAndLoadURL(this.getURL(), null);
        }
    },
    replaceInCurrentSelection(queryPart) {
        // they can be equal -> clear all
        if (this.currentSelection === queryPart) {
            logger.log('Clear query.');
            this.currentSelection = '';
        }
        // the query can be inside the current selection - then it must be followed by a colon -> remove it
        else if (this.currentSelection.indexOf(queryPart + ':') >= 0) {
            logger.log('Remove ' + queryPart + ' from query.');
            this.currentSelection = this.currentSelection.replace(queryPart + ':', ':');
        }
        // the query can be at the end -> remove it
        else if (this.currentSelection.length > 0 &&
                this.currentSelection.lastIndexOf(queryPart) > 0 &&
                this.currentSelection.lastIndexOf(queryPart) === (this.currentSelection.length - queryPart.length)) {
            logger.log('Remove ' + queryPart + ' from the end of the query.');
            let end               = this.currentSelection.length - queryPart.length;
            this.currentSelection = this.currentSelection.substring(0, end);
        }
        // add it
        else {
            logger.log('Add ' + queryPart + ' to query.');
            this.currentSelection = this.currentSelection + queryPart;
        }
    },
    changeAndLoadURL(url, callback) {
        historyService.pushState({oldUrl: document.location.href}, url);
        this.loadNow(url + '&type=fragment', callback);
    },
    loadNow(url, callback) {
        // TODO: remove this function tunnel
        // TODO: lock screen to prevent multiple submits. Unlock after response received
        this.loadProducts(url, callback);
    },
    getURL() {
        let url = null;
        if (this.currentSelection === '') {
            url = this.queryUrl + '?fq=' + this.searchTerm;
        } else {
            url = this.queryUrl + '?fq=' + encodeURIComponent(this.currentSelection) + '&q=' + encodeURIComponent(this.searchTerm);
        }
        return url;
    },
    resetFacet(target, callback) {
        this.removeFacetFromCurrentSelection(target);
        this.changeAndLoadURL(this.getURL(), callback);
    },
    loadProducts(url, callback) {
        spinner.visibility(true);
        plpService.fetchFragment(url)
                  .then((data) => {
                              plpService.replaceFilterBar(data);
                              // facet clearing removes sorting
                              if (this.currentSelection === '') {
                                  logger.log('restore the wrong state of currentSelection');
                                  this.currentSelection = $(data).filter('#plp__fragment__facets').data('currentQuery');
                              }
                              plpService.replaceFacets(data);
                              plpService.addAppliedFacetsDesktop();
                              plpService.addAppliedFacetsMobile();
                              plpService.exchangeProducts(data);
                              parallax.reloadParallaxPool();
                              mediaLazyLoad.refreshLazyLoad();
                              productTileSlider.reInit();
                              rbataTileSwatches.reInit();
                              startCloudinaryResponsive();
                              if (callback && typeof (callback) === typeof (Function)) {
                                  logger.log('execute some callback function');
                                  callback();
                              }
                          }, (jqXHR, textStatus) => {
                              logger.error(`loadProducts failed: ${textStatus}`);
                          }
                  ).always(() => {
            spinner.visibility(false);
        });
    },

    initFacetSelection() {
        const facetConfig = document.querySelector('#js-facetconfig-selector');
        if (facetConfig) {
            facetSelection.cacheSelectors();
            facetSelection.initFacet(facetConfig.dataset);
            facetSelection.bindHandlers();
            plpService.addAppliedFacetsDesktop();
            plpService.addAppliedFacetsMobile();
            // https://code.google.com/p/chromium/issues/detail?id=63040
            let state          = history.state || {};
            state.initialToken = true;
            historyService.replaceState(state, null);
        }
    }
};

$(() => {
    facetSelection.initFacetSelection();
});

export default facetSelection;